import getActions from "./actionsPopupUtils";

const agent_attorney_individs_actions = (formName, isSubaccount) => {
  return getActions({ formName, isSubaccount, shared: true });
};

export default agent_attorney_individs_actions;
